import { addDoc, getDocs, deleteDoc, collection, query, where, doc } from "firebase/firestore";
import { db, auth } from "../../config/firebase";
import { useEffect, useState } from "react";
import { Post } from "../home/Home";
import { Post as PostView } from "../Post/Post";
import { useAuthState } from "react-firebase-hooks/auth";
import { useContext } from "react";
import { AppContext } from "../../App";
import { useNavigate } from "react-router-dom";

export const UserPage = () => {
  const { selectedUserId: userId } = useContext(AppContext);
  const { selectedUsername: username } = useContext(AppContext);

  const [postsList, setPostsList] = useState<Post[] | null>();

  const [user, loading, error] = useAuthState(auth);
  const [loadingVisisble, setLoadingVisisble] = useState<boolean>(false);

  const navigate = useNavigate();

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  let delayTime = 20;
  const getPosts = async () => {
    try {
      setLoadingVisisble(true);
      await delay(delayTime);

      const postRef = collection(db, "posts");
      const userPosts = query(postRef, where("userId", "==", userId));
      const data = await getDocs(userPosts);

      setPostsList(data.docs.map(doc => ({ ...doc.data(), id: doc.id })) as Post[]);
      setLoadingVisisble(false);
    } catch (error) {}
  };

  useEffect(() => {
    userId === "" && navigate("/");

    getPosts();
  }, []);
  return (
    <div>
      <h4>
        <span className='fst-italic fw-bolder'>@{username}</span>'s Posts
      </h4>
      <div className='d-flex flex-column justify-content-center align-content-center mx-auto'>
        {postsList?.map(p => (
          <PostView post={p} refreshPosts={getPosts} />
        ))}
      </div>
      {loadingVisisble && (
        <div className='spinner-border my-2' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      )}
      {!loadingVisisble && (
        <button
          className='btn btn-secondary my-3'
          onClick={() => {
            delayTime = 500;
            getPosts();
          }}>
          Refresh &#x21bb;
        </button>
      )}
    </div>
  );
};
